import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  manualStore: {
    description: 'Store Dropdown selection when a user only has one manual store.',
    defaultMessage: 'Manual Store',
    id: 'IjYaEM',
  },
  selectStore: {
    description: 'Store Dropdown default text when no store is selected',
    defaultMessage: 'Select Store',
    id: 'WfGef1',
  },
  selectManualStore: {
    description: 'Label for Store Dropdown selection',
    defaultMessage: 'Select Manual Store',
    id: '/meNXQ',
  },
  selectStoreDefaultTitle: {
    defaultMessage: 'Select a Store',
    id: 'xrCLy7',
    description: 'Default text for store dropdown when no store is selected',
  },
});
